/**
 * COPIED from pages/dev-agent/components/metadataEditor/buildPackageTabs.ts (no store coupling).
 * The multi-agent store has no `virtualFiles` slice, so callers pass `{}` —
 * the param is kept so the copied panel logic matches dev-agent verbatim.
 */
import type { EditorTab } from "@ncoder/code-editor";
import type { OpenFile } from "./types";
import { getMonacoLanguage } from "./monacoLanguage";

type VirtualFileMap = Record<
  string,
  { content: string; metadataType: string; name: string }
>;

export function buildPackageTabs(params: {
  openFiles: OpenFile[];
  activeFileId: string | null;
  viewingMain: boolean;
  contentByFileId: Record<string, string>;
  dirtyByFileId: Record<string, boolean>;
  originalByFileId: Record<string, string>;
  initialContent?: Record<string, string>;
  virtualFiles: VirtualFileMap;
}): EditorTab[] {
  const {
    openFiles,
    activeFileId,
    viewingMain,
    contentByFileId,
    dirtyByFileId,
    originalByFileId,
    initialContent,
  } = params;

  return openFiles.map((f) => {
    const isActive = f.id === activeFileId;
    const showMain = isActive && viewingMain;
    return {
      id: f.id,
      label: f.name,
      language: getMonacoLanguage(f.name, f.metadataType),
      fileName: f.name,
      // Fall back to `initialContent` so an artifact tab opened with seeded
      // content (e.g. a refactor opened via MA-15) shows its code BEFORE the
      // user edits it — otherwise the tab renders blank ("code disappears").
      value: showMain
        ? (originalByFileId[f.id] ?? contentByFileId[f.id] ?? initialContent?.[f.id] ?? "")
        : (contentByFileId[f.id] ?? initialContent?.[f.id] ?? ""),
      isDirty: showMain
        ? false
        : (dirtyByFileId[f.id] ?? false),
      // Renders italic, exactly as in the Metadata Explorer, so "this tab will be
      // replaced by your next click" is visible rather than something to discover.
      isPreview: f.isPreview ?? false,
      meta: { metadataType: f.metadataType },
    };
  });
}
